// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
 .star-magic {
    display: inline-block;
    animation: magic-shine 3s infinite;
    position: relative;
  }

  .star-magic::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 4px;
    background: radial-gradient(circle, #fff 0%, transparent 70%);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: magic-dot 3s infinite;
    opacity: 0;
  }

  @keyframes magic-shine {
    0%, 100% { 
      transform: scale(1) rotate(0deg);
      filter: brightness(1) saturate(1);
    }
    25% { 
      transform: scale(1.2) rotate(90deg);
      filter: brightness(1.5) saturate(1.5);
    }
    50% { 
      transform: scale(1.1) rotate(180deg);
      filter: brightness(2) saturate(2);
    }
    75% { 
      transform: scale(1.3) rotate(270deg);
      filter: brightness(1.5) saturate(1.5);
    }
  }

  @keyframes magic-dot {
    0%, 80%, 100% { 
      opacity: 0; 
      transform: translate(-50%, -50%) scale(0); 
    }
    40%, 60% { 
      opacity: 1; 
      transform: translate(-50%, -50%) scale(1); 
    }
  }

  /* Enhanced version with more magic particles (optional) */
  .star-magic-enhanced {
    display: inline-block;
    animation: magic-shine 3s infinite;
    position: relative;
  }

  .star-magic-enhanced::before,
  .star-magic-enhanced::after {
    content: '';
    position: absolute;
    width: 3px;
    height: 3px;
    background: radial-gradient(circle, #ffdf00 0%, transparent 70%);
    border-radius: 50%;
    animation: magic-particles 3s infinite;
    opacity: 0;
  }

  .star-magic-enhanced::before {
    top: 20%;
    left: 20%;
    animation-delay: 0.5s;
  }

  .star-magic-enhanced::after {
    bottom: 20%;
    right: 20%;
    animation-delay: 1.5s;
  }

  @keyframes magic-particles {
    0%, 90%, 100% { 
      opacity: 0; 
      transform: scale(0) translateY(0px);
    }
    30%, 70% { 
      opacity: 1; 
      transform: scale(1) translateY(-10px);
    }
  }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;CACC;IACG,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,6DAA6D;IAC7D,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE;MACE,gCAAgC;MAChC,iCAAiC;IACnC;IACA;MACE,mCAAmC;MACnC,qCAAqC;IACvC;IACA;MACE,oCAAoC;MACpC,iCAAiC;IACnC;IACA;MACE,oCAAoC;MACpC,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,UAAU;MACV,yCAAyC;IAC3C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;EACF;;EAEA,0DAA0D;EAC1D;IACE,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gEAAgE;IAChE,kBAAkB;IAClB,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE;MACE,UAAU;MACV,mCAAmC;IACrC;IACA;MACE,UAAU;MACV,qCAAqC;IACvC;EACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n .star-magic {\n    display: inline-block;\n    animation: magic-shine 3s infinite;\n    position: relative;\n  }\n\n  .star-magic::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 4px;\n    height: 4px;\n    background: radial-gradient(circle, #fff 0%, transparent 70%);\n    border-radius: 50%;\n    transform: translate(-50%, -50%);\n    animation: magic-dot 3s infinite;\n    opacity: 0;\n  }\n\n  @keyframes magic-shine {\n    0%, 100% { \n      transform: scale(1) rotate(0deg);\n      filter: brightness(1) saturate(1);\n    }\n    25% { \n      transform: scale(1.2) rotate(90deg);\n      filter: brightness(1.5) saturate(1.5);\n    }\n    50% { \n      transform: scale(1.1) rotate(180deg);\n      filter: brightness(2) saturate(2);\n    }\n    75% { \n      transform: scale(1.3) rotate(270deg);\n      filter: brightness(1.5) saturate(1.5);\n    }\n  }\n\n  @keyframes magic-dot {\n    0%, 80%, 100% { \n      opacity: 0; \n      transform: translate(-50%, -50%) scale(0); \n    }\n    40%, 60% { \n      opacity: 1; \n      transform: translate(-50%, -50%) scale(1); \n    }\n  }\n\n  /* Enhanced version with more magic particles (optional) */\n  .star-magic-enhanced {\n    display: inline-block;\n    animation: magic-shine 3s infinite;\n    position: relative;\n  }\n\n  .star-magic-enhanced::before,\n  .star-magic-enhanced::after {\n    content: '';\n    position: absolute;\n    width: 3px;\n    height: 3px;\n    background: radial-gradient(circle, #ffdf00 0%, transparent 70%);\n    border-radius: 50%;\n    animation: magic-particles 3s infinite;\n    opacity: 0;\n  }\n\n  .star-magic-enhanced::before {\n    top: 20%;\n    left: 20%;\n    animation-delay: 0.5s;\n  }\n\n  .star-magic-enhanced::after {\n    bottom: 20%;\n    right: 20%;\n    animation-delay: 1.5s;\n  }\n\n  @keyframes magic-particles {\n    0%, 90%, 100% { \n      opacity: 0; \n      transform: scale(0) translateY(0px);\n    }\n    30%, 70% { \n      opacity: 1; \n      transform: scale(1) translateY(-10px);\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
